import { useEffect, useState } from 'react';

/**
 * Returns `value`, updated only after `delayMs` has elapsed without a new
 * change. Used to debounce the live-search input (mirrors the 140ms timer in
 * the prototype's public/client.js `run()` debounce).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(id);
    }, [value, delayMs]);

    return debounced;
}
